import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VMain,[(_vm.bestaetigungscode)?_c('bestaetigung',{attrs:{"code":_vm.bestaetigungscode}}):_c('anmeldung')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }